<template>
  <div :class="['goal-list-confidence-chart']">
    <no-data v-if="!hasData" />
    <base-chart
      v-else
      :options="chartOptions"
    />
  </div>
</template>

<script setup>
import BaseChart from '@/components/dashboard/BaseChart.vue';
import NoData from '@/components/dashboard/NoData.vue';
import useStatusScoreChart from '@/composables/grid-page/chart/status-score-chart';
import { DateTime } from 'luxon';
import { computed } from 'vue';

const props = defineProps({
  startDate: {
    type: Date,
    required: true,
  },
  endDate: {
    type: Date,
    required: true,
  },
  chartData: {
    type: Array,
    default: () => [],
  },
});

const chartResult = computed(() => ({
  statusScoreData: props.chartData,
  startDate: DateTime.fromJSDate(props.startDate),
  endDate: DateTime.fromJSDate(props.endDate),
}));

const { chartOptions, hasData } = useStatusScoreChart(chartResult);
</script>
